/**
 * Usage:
 * ```
 * import 'core/sentry'
 * ```
 */

import {APP_VERSION, ENVIRONMENT, RAVEN_CONFIG_DSN} from 'core/env'
import * as Raven from 'raven-js'

const dsn = RAVEN_CONFIG_DSN
if (typeof dsn === 'string' && dsn.length > 0) {
  Raven
    .config(dsn, {
      release: APP_VERSION,
      environment: ENVIRONMENT,
    })
    .install()
} else {
  console.warn('No SENTRY_DSN specified, Raven not running')
}

export {Raven as default}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/sentry.ts